// extracted by mini-css-extract-plugin
export default {"header":"rK","container":"sK","accordeonitem":"tK","itemsticky":"uK","itemopen":"vK","open":"wK","productname":"xK","productinfo":"yK","flavorstext":"zK","invalidlimit":"AK","limit":"BK","scrollUpAccordion":"CK","wrapper":"EK"};
    if(module.hot) {
      // 1715091679947
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  